import * as L from 'leaflet';
import 'leaflet.heat';
import { MapLayer } from './mapLayer.abstract';

export class HeatLayer extends MapLayer {
  points = new Array<L.LatLng>();

  constructor(id: string, name?: string) {
    super(id, name);
    this.options.setOptions({
      minOpacity: 0.5,
      maxZoom: 10,
      max: 1.0,
      radius: 25,
      blur: 15,
      gradient: null, // {0.4: 'blue', 0.65: 'lime', 1: 'red'};)
      pane: 'customHeatPane',
    });
  }

  public addPoint(lat: number, lon: number, intensity = 1.0): this {
    // uses optional altitude param for intensity
    this.points.push(new L.LatLng(lat, lon, intensity > 1.0 ? 1.0 : intensity));
    return this;
  }

  public getLeafletLayer(): Promise<L.Layer> {
    return Promise.resolve(L.heatLayer(this.points, this.options.getAll()));
  }

  protected getCanvas(): null | HTMLElement {
     
    return this.leafletMapLayer != null && this.leafletMapLayer['_canvas'] != null
      ?  
      (this.leafletMapLayer['_canvas'] as HTMLElement)
      : null;
  }

  protected updateLeafletLayerOpacity(): void {
    const canvas = this.getCanvas();
    if (canvas != null) {
      const opacity = this.hidden.get() ? 0.0 : this.options.opacity.get();
      canvas.style.opacity = String(opacity);
    }
  }

  // override for layer specific operations
  protected preLayerAdd(): Promise<void> {
    return Promise.resolve().then(() => this.ensurePaneExists(this.options.pane.get(), 430));
  }

  // override for layer specific operations
  protected postLayerAdd(): Promise<void> {
    return new Promise<void>((resolve) => {
      if (this.leafletMapLayer != null) {
         
        this.leafletMapLayer['bringToFront'] = (): void => this.bringHeatToFront();
         
        this.leafletMapLayer['bringToBack'] = (): void => this.setZIndex(0);
      }
      resolve();
    });
  }

  protected bringHeatToFront(): void {
    const canvas = this.getCanvas();
    if (canvas != null) {
      let maxZ = 0;
      // find max zIndex of siblings
       
      Array.from(canvas.parentElement!.children).forEach((element: HTMLElement) => {
        // console.debug('sibling', element.style.zIndex);
        if (element !== canvas) {
          maxZ = Math.max(maxZ, Number(element.style.zIndex));
        }
      });
      canvas.style.zIndex = String(maxZ + 1);
      // console.debug('bringHeatToFront', canvas.style.zIndex);
    }
  }
  protected setZIndex(zIndex: number): void {
    // console.debug('setZIndex', zIndex);
    const canvas = this.getCanvas();
    if (canvas != null) {
      canvas.style.zIndex = String(zIndex);
    }
  }
}
